import * as React from 'react';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Loading} from '../Loading';
import {IOuter} from './GlobalLoader.types';

export const GlobalLoader: React.FunctionComponent<IOuter> = () => {
  const {t} = useTranslation();

  useEffect(() => {
    const statusText = document.getElementById('statusLoadingText');
    const arcs = document.getElementById('loadingSpinner');
    if (!statusText || !arcs) {
      return;
    }

    arcs.hidden = true;

    statusText.innerText = t('mgw.acc.loading');

    return () => {
      statusText.innerText = '';
    };
  }, []);

  return <Loading />;
};

GlobalLoader.displayName = 'GlobalLoader';
